const log = {
    invalid_type: 'Geçersiz günlük türü.',
};
export default log;
